import React, { useContext } from "react";

import TabsContext from "../tabs-context";

import { IProps } from "./tabs-item.types";

/**
 * Display the contents of a tab if selected.
 * @param props.children Tab content.
 * @param props.tabId    Identifier that links tab buttons and tab content.
 * @returns              Tab content element.
 */
const TabsItem = ({ children, tabId }: IProps) => {
    const { activeTabId } = useContext(TabsContext);
    return activeTabId === tabId ? <>{children}</> : null;
};

export default TabsItem;
